import actions from './actions';

const {
  GET_DATA_BEGIN,
  GET_DATA_SUCCESS,
  GET_DATA_ERR,
  SET_UPDATED,
  SET_CURRENT,
} = actions;

const initialState = {
  data: [] as any[],
  current: null as any,
  loading: false,
  error: null,
};

const warehouseRequestsReducer = (state = initialState, action: any) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_DATA_BEGIN:
      return { ...state, loading: true };
    case GET_DATA_SUCCESS:
      return {
        ...state,
        data: data.results || data,
        loading: false,
      };
    case GET_DATA_ERR:
      return { ...state, error: err, loading: false };
    case SET_UPDATED:
      return {
        ...state,
        data: state.data.map((item: any) =>
          (item.id || item._id) === (data.id || data._id) ? data : item
        ),
        current:
          state.current && (state.current.id || state.current._id) === (data.id || data._id)
            ? data
            : state.current,
        loading: false,
      };
    case SET_CURRENT:
      return { ...state, current: data, loading: false };
    default:
      return state;
  }
};

export { warehouseRequestsReducer };
